@if (!inRegistration) {
  <app-header></app-header>
}
<main role="main" class="flex-1">
  <div class="container-fluid h-100 d-flex justify-content-center align-items-center">
    <div class="page-content flex-fill w-100">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>
@if (!inRegistration) {
  <app-footer></app-footer>
}
